<form id="addPrincipalForm" ngSubmit="addPrincipal()" [formGroup]="addPrincipalForm">
    <div class="row" style="border: none;">
        <div class="col-sm-3" style="text-align: right; font-weight: bold;">Select a School Type:
        </div>
        <div class="col-sm-3">
            <select id="SchoolType" formControlName="SchoolType" (change)="filterSchoolBySchoolType()">
                <option value="0">All School Types</option>
                <option *ngFor="let schoolType of schoolTypeList" value="{{schoolType.SchoolType}}">{{schoolType.Description}}</option>
            </select>
        </div>
    </div><br>
    <div class="row">
        <div class="col-sm-3" style="text-align: right; font-weight: bold;">Select a School:
        </div>
        <div class="col-sm-3">
            <select id="OrgUnit" formControlName = "OrgUnit" (change)="filterPrincipalBySchool()">
                <option value="0">All {{selectedSchoolTypeName}} Schools</option>
                <option *ngFor="let school of schoolList" value="{{school.OrgUnit}}">{{school.School}}</option>
            </select>
        </div>
    </div><br>
    <div class="example-container mat-elevation-z8" style="border:none;">
        <mat-table #table [dataSource]="datasource" matSort>
            <ng-container matColumnDef="Principal">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Principal Name {{numberOfPrincipals}}</mat-header-cell>
                <mat-cell class="PrincipalName-cell" *matCellDef="let principal">
                    <span class="mobile-label">Principal Name: </span>
                    {{principal.Principal}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="School">
                <mat-header-cell *matHeaderCellDef mat-sort-header>School</mat-header-cell>
                <mat-cell class="School-cell" *matCellDef="let principal">
                    <span class="mobile-label">School: </span>
                    {{principal.School}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="SchoolType">
                <mat-header-cell *matHeaderCellDef mat-sort-header>School Type</mat-header-cell>
                <mat-cell class="SchoolType-cell" *matCellDef="let principal">
                    <span class="mobile-label">School Type: </span>
                    {{principal.SchoolType}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Status">
                <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
                <mat-cell class="Status-cell" *matCellDef="let principal">
                    <span class="mobile-label">Status: </span>
                    {{principal.Status}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="action">
                <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
                <mat-cell class="Action-cell" *matCellDef="let principal">
                    <span class="mobile-label">Action:</span>
                    Edit
                </mat-cell>
            </ng-container>
        
            <mat-header-row *matHeaderRowDef="displayedColumns sticky: true" style="color:darkgray; font: bold;"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
    </div><br>
    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    <div class="col-sm-3">
        <button id="addPrincipalBtn" type="submit" [disabled]="!newPrincipal" (click)="addNewPrincipal()">Add The Principal</button>
    </div>
</form>